module.exports = __webpack_public_path__ + "img/util-date-down.f5596a5e.svg";